import { useState } from 'react';
import { AssignableRole } from 'src/common/roleRegistry/roleRegistry';
import { getAssignableRolesInSameGroup } from 'src/common/roleRegistry/roleRegistryHelpers';
import {
  RoleChangeCallout,
  deriveRoleChangeCallouts,
} from 'src/components/ContactFormComponents/ChangeUserRoleDialogue/utils/deriveRoleChangeCallouts';

export interface UseChangeRoleFormStateReturn {
  availableRoles: readonly AssignableRole[];
  callouts: RoleChangeCallout[];
  selectedRole: AssignableRole | null;
  setSelectedRole: (role: AssignableRole) => void;
  isValid: boolean;
  reset: () => void;
}

export const useChangeRoleFormState = (
  currentRole: string
): UseChangeRoleFormStateReturn => {
  const availableRoles: readonly AssignableRole[] =
    getAssignableRolesInSameGroup(currentRole);

  const callouts: RoleChangeCallout[] = deriveRoleChangeCallouts(currentRole);

  const [selectedRole, setSelectedRoleState] =
    useState<AssignableRole | null>(null);

  const setSelectedRole = (role: AssignableRole) => {
    setSelectedRoleState(role);
  };

  const reset = () => {
    setSelectedRoleState(null);
  };

  const isValid: boolean =
    selectedRole !== null && selectedRole !== currentRole;

  return {
    availableRoles,
    callouts,
    selectedRole,
    setSelectedRole,
    isValid,
    reset,
  };
};
